import React from 'react';

const withPromise = promise => Component => props => {
  const {
    onSubmit=function(){},
    onSuccess=function(){},
    onError=function(){},
    ...otherProps
  } = props;

  const pending = React.useRef(false);
  const [error, setError] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = (...args) => {
    if(pending.current) return;

    pending.current = true;
    setLoading(true);
    onSubmit(...args);

    return promise(...args)
      .then((res) => {
        setError(null);
        onSuccess(res);
      })
      .catch((error) => {
        setError(error.message);
        onError(error);
      })
      .finally(() => {
        pending.current = false;
        setLoading(false);
      });
  };

  return <Component loading={loading} error={error} onSubmit={handleSubmit} {...otherProps} />;
};

export default withPromise;
